// 页面三级权限
import { mapState } from "vuex";

export default {
  data() {
    return {
      operations: [],
      noChildMunuList: ["积分设置", "消息推送", "数据统计"],
    };
  },
  created() {
    this.getOperation();
  },
  computed: {
    ...mapState(["operationList"]),
  },
  methods: {
    getOperation() {
      const { meta } = this.$route;
      console.log(meta);
      this.operationList.forEach((item) => {
        if (meta.length >= 1) {
          if (!this.noChildMunuList.includes(item.name) && meta[meta.length - 1].name === item.name) {
            console.log(111);

            this.operations = item.operations;
          } else if (this.noChildMunuList.includes(item.name) && meta[0].name === item.name) {
            console.log(222, item.operations);
            this.operations = item.operations;
          }
        }
      });
    },
  },
};
